import React from "react";
import { useNavigate } from "react-router-dom";
import {
  abujaRoomImage1,
  abujaRoomImage2,
  abujaRoomImage3,
  ogunRoomImage1,
  ogunRoomImage2,
  ogunRoomImage3,
  priceImage,
  roomsImage1,
  roomsImage2,
  roomsImage3,
  roomsImage4,
  roomsImage5,
  roomsImage6,
} from "../assets";

const NewRooms = ({ location }) => {
  const navigate = useNavigate();

  const handleNavigation = (location) => {
    navigate(`/booking?location=${location}`);
  };

  return (
    <div className="md:px-[100px] px-4 mb-16">
      <div className="text-[#00A859] mb-4">
        <span className="font-bold font-barlow text-sm tracking-widest">
          WOSAM LUXURY APARTMENT
        </span>
        <h1 className="md:text-3xl md:leading-[48px] font-trajan  text-2xl font-bold text-[#FF9900] mt-4">
          ROOMS & SUITES
        </h1>
      </div>

      {location === "LAGOS" && (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
          <div className="relative text-white">
            <img src={roomsImage1} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("lagos")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦70000</p>
              <p className="font-semibold text-lg">Studio Apartment</p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={roomsImage6} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("lagos")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦100000</p>
              <p className="font-semibold text-lg">
                Standard One Bedroom Suite
              </p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={roomsImage2} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("lagos")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦110000</p>
              <p className="font-semibold text-lg">
                Business One Bedroom Suite
              </p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={roomsImage3} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("lagos")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦150000</p>
              <p className="font-semibold text-lg">
                Deluxe Two Bedroom Apartment
              </p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={roomsImage4} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("lagos")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦180000</p>
              <p className="font-semibold text-lg">
                Executive Three Bedroom Apartment
              </p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={roomsImage5} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("lagos")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦200000</p>
              <p className="font-semibold text-lg">
                Luxury Two Bedroom Apartment with Cinema
              </p>
            </div>
          </div>
        </div>
      )}

      {location === "ABUJA" && (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
          <div className="relative text-white">
            <img src={abujaRoomImage1} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("abuja")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦150000</p>
              <p className="font-semibold text-lg">Presidential One Bed Apartment</p>
            </div>
          </div>

          <div className="relative text-white">
            <img src={abujaRoomImage2} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("abuja")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦450000</p>
              <p className="font-semibold text-lg">Presidential Three Bed Apartments</p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={abujaRoomImage3} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("abuja")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦600000</p>
              <p className="font-semibold text-lg">Presidential Four Bed Terrace</p>
            </div>
          </div>
        </div>
      )}
      {location === "OGUN" && (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
          <div className="relative text-white">
            <img src={ogunRoomImage1} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("ogun")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦80000</p>
              <p className="font-semibold text-lg">One Bedroom Suite</p>
            </div>
          </div>

          <div className="relative text-white">
            <img src={ogunRoomImage2} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("ogun")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦120000</p>
              <p className="font-semibold text-lg">Executive One Bedroom Suite</p>
            </div>
          </div>
          <div className="relative text-white">
            <img src={ogunRoomImage3} alt="" className="" />
            <div className="absolute md:top-6 md:right-6 top-4 right-4">
              <button
                className="md:py-2 py-2 px-4 text-white bg-[#00A859] font-bold text-sm"
                onClick={() => handleNavigation("ogun")}
              >
                BOOK NOW
              </button>
            </div>
            <div className="absolute md:bottom-10 md:left-10 bottom-4 left-4 font-barlow">
              <div className="h-1 w-[50px] bg-[#FF9900] mb-2 rounded-md"></div>
              <p className="font-light">₦150000</p>
              <p className="font-semibold text-lg">Two Bedroom Apartment</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewRooms;
